module.exports = __webpack_public_path__ + "static/img/home_3.638e10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/home_3.png
// module id = QW3i
// module chunks = 4